export const TRACKING_EVENTS = {
  LOGIN: 'dl_login',
  SIGN_UP: 'dl_sign_up',
  VIEW_CART: 'dl_view_cart',
  VIEW_ITEM: 'dl_view_item',
  SUBSCRIBE: 'dl_subscribe',
  USER_DATA: 'dl_user_data',
  ADD_TO_CART: 'dl_add_to_cart',
  SELECT_ITEM: 'dl_select_item',
  PAGE_VIEW: 'dl_route_update',
  VIEW_ITEM_LIST: 'dl_view_item_list',
  REMOVE_FROM_CART: 'dl_remove_from_cart',
  VIEW_SEARCH_RESULTS: 'dl_view_search_results',
};
